import { authJsonPost, getAuth } from "functions/BaseAxios";
import { showAlert } from "../general/action";

export const GIVEAWAY_DATA = 'GIVEAWAY_DATA';
export const GIVEAWAY_CHECK = 'GIVEAWAY_CHECK';
export const GIVEAWAY_JOB = 'GIVEAWAY_JOB';
export const GIVEAWAY_DETAIL = 'GIVEAWAY_DETAIL';
export const GIVEAWAY_DETAIL_USER = 'GIVEAWAY_DETAIL_USER';
export const ALERT_MODAL = 'ALERT_MODAL';



export function getGiveaway(params?: string) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            data = await getAuth(`auth/giveaway?q=${params}`)
        } catch (error) {
            data = { code: 201 }
        }

        dispatch({
            type: GIVEAWAY_DATA,
            payload: data.code === 200 ? data?.payload.data : []
        })
    }
}


export function getGiveawayCheck(params?: string) {
    return async (dispatch: DispatchGeneral) => {
        let data;

        try {
            data = await getAuth(`auth/giveaway/check?q=${params}`)
        } catch (error) {
            data = { code: 201 }
        }

        dispatch({
            type: GIVEAWAY_CHECK,
            payload: data.code === 200 ? data?.payload.data : null
        })
    }
}

export function getGiveawayJobs(params?: string) {
    return async (dispatch: DispatchGeneral) => {
        let data;

        try {
            data = await getAuth(`auth/giveaway/jobs?q=${params}`)
        } catch (error) {
            data = { code: 201 }
        }

        dispatch({
            type: GIVEAWAY_JOB,
            payload: data.code === 200 ? data?.payload.data : null
        })
    }
}


export function getGiveawayDetail(params?: string) {
    return async (dispatch: DispatchGeneral) => {
        let data;

        try {
            data = await getAuth(`auth/giveaway/detail?q=${params}`)
        } catch (error) {
            data = { code: 201 }
        }

        dispatch({
            type: GIVEAWAY_DETAIL,
            payload: data.code === 200 ? data?.payload.data : []
        })
    }
}

export function postVoteGiveawayDetail(params?: number, stat?: boolean) {
    return async (dispatch: DispatchGeneral) => {
        let data;

        try {
            let form = {
                'id': params,
                'stat': stat
            }
            data = await authJsonPost(form, 'auth/giveaway/detail/vote')
        } catch (error) {
            data = { code: 201 }
        }

        if (data.code == 200) {
            dispatch({
                type: GIVEAWAY_DETAIL,
                payload: data.code === 200 ? data?.payload.data : []
            })
        } else if (data.code == 201) {
            dispatch({
                type: ALERT_MODAL,
                payload: {
                    content: 'You cant vote again',
                    title: 'info',
                    show: true
                },
            });
        }
    }
}

let numberPage = 0;

export function updateShowItemGiveaway(val: number) {
    numberPage = val;
}

export function getShowItemGiveaway() {
    return numberPage;
}

export function getGiveawayDetailUser(start?: number, array: any = []) {
    return async (dispatch: DispatchGeneral) => {
        let data;

        try {
            data = await getAuth(`auth/giveaway/detail/user?start=${start === undefined ? 0 : start}`)
        } catch (error) {
            data = { code: 201 }
        }

        let dataArray;
        if (array) {
            dataArray = array;
            data?.payload?.data.map((item: any, key: number) => {
                dataArray.push(item)
            })

            if (data.payload.data.length == 0) {
                updateShowItemGiveaway(getShowItemGiveaway() - 1);
            }
        } else {
            updateShowItemGiveaway(0)
        }

        if (data.code == 200) {
            dispatch({
                type: GIVEAWAY_DETAIL_USER,
                payload: data.code === 200 ? array ? dataArray : data.payload.data : [],
            })
        }
    }
}


export const showAlertGiveaway = (content: any, title: any, show: boolean) => {
    return async (dispatch: DispatchGeneral) => {
        dispatch({
            type: ALERT_MODAL,
            payload: {
                content,
                title,
                show
            },
        });
    };
}